import { render, staticRenderFns } from "./RepetitionDays.vue?vue&type=template&id=0278a4b2&scoped=true"
import script from "./RepetitionDays.vue?vue&type=script&lang=js"
export * from "./RepetitionDays.vue?vue&type=script&lang=js"
import style0 from "./RepetitionDays.vue?vue&type=style&index=0&id=0278a4b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0278a4b2",
  null
  
)

export default component.exports